/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Edit_TitleInputs */

const en_admin_payments_edit_title = /** @type {(inputs: Admin_Payments_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Order`)
};

const zh_admin_payments_edit_title = /** @type {(inputs: Admin_Payments_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑订单`)
};

/**
* | output |
* | --- |
* | "Edit Order" |
*
* @param {Admin_Payments_Edit_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_edit_title = /** @type {((inputs?: Admin_Payments_Edit_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Edit_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_edit_title(inputs)
	return zh_admin_payments_edit_title(inputs)
});
export { admin_payments_edit_title as "admin.payments.edit_title" }